




















































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { getSeedKpDetail, getSeedKpList, setKpField, updateKpField } from '@/api/kp';
import { startupMaturityList, CEOSuitabilityList, maintenanceStrategyList, kpSeedColumns } from '@/utils/kp';

import { search, searchNickName, searchNickNamePage } from '@/api/common.js';

import selectMember from '@/components/project/selectMember.vue';
import kpEdit from '@/components/kp/kpEdit.vue';
import kpTableItem from '@/components/kp/kpTableItem.vue';
import moment from 'moment';
import { seedTableMap } from '@/common/constant.js';

@Component({
  components: {
    selectMember,
    kpEdit,
    kpTableItem
  }
})
class KPList extends Vue {
  columns: any[] = kpSeedColumns;
  data: any[] = [];
  showKpEdit: boolean = false;
  moment: any = moment;
  filterInfo: object = {
    startupMaturity: undefined,
    CEOSuitability: undefined,
    maintenanceStrategy: undefined,
    startTime: undefined,
    endTime: undefined,
    keyWord: '',
    maintainer: undefined
  };
  tableLoading: boolean = true;
  confirmLoading: boolean = false;

  fetching: boolean = false;
  userKeyWord: string = '';
  userPagination: object = {
    page: 1,
    total: 0
  };
  userid: any = '';
  userList: Array<object> = [];

  kpEditInfo: object = {};
  kpEditType: string = 'new';

  showDevelopment: boolean = false;
  developmentNow: string = '';
  developmentUser: string = '';
  developmentId: number = 0;

  pageInfo: object = {
    page: 1,
    pageSize: 10,
    total: 0,
    needPageInfo: false
  };

  seedTable: string = '';

  startupMaturityList: Array<string> = startupMaturityList;
  CEOSuitabilityList: Array<string> = CEOSuitabilityList;
  maintenanceStrategyList: Array<string> = maintenanceStrategyList;

  @Prop()
  collapsed;

  @Watch('collapsed')
  getCollapsed(val) {
    setTimeout(() => {
      this.$forceUpdate();
    }, 80);
  }

  created() {
    this.seedTable = seedTableMap[window.location.host];
    this.getList();
  }

  async getList() {
    try {
      this.pageInfo = this.pageInfo['needPageInfo']
        ? this.pageInfo
        : {
          page: 1,
          pageSize: 10,
          total: 0,
          needPageInfo: false
        };
      let body = { ...this.filterInfo, page: this.pageInfo['page'], pageSize: this.pageInfo['pageSize'] };
      for (let key in body) {
        if (!body[key]) {
          delete body[key];
        }
      }
      this.tableLoading = true;
      let res = await getSeedKpList(body);
      if (res.code === 200) {
        let data = res.data.list;
        data.forEach(userInfo => {
          userInfo.educationExperience.value = userInfo.educationExperience.value.replace(/<a href/g, '<a target="_blank" href');
          userInfo.workExperience.value = userInfo.workExperience.value.replace(/<a href/g, '<a target="_blank" href');
          userInfo.individuality.value = userInfo.individuality.value.replace(/<a href/g, '<a target="_blank" href');
          (userInfo.latestDevelopment || []).forEach(_ => {
            _.value = _.value.replace(/<a href/g, '<a target="_blank" href');
          });
        });
        this.data = data;
        this.tableLoading = false;
        this.pageInfo['needPageInfo'] = false;
        this.pageInfo['total'] = res.data.total;
      }
    } catch (err) {
      console.log(err);
    }
  }

  // 切换分页
  pageChange(page, pageSize) {
    this.pageInfo['page'] = page;
    this.pageInfo['pageSize'] = pageSize;
    this.pageInfo['needPageInfo'] = true;
    this.getList();
  }

  dateChange(date, dateString) {
    //@ts-ignore
    this.$ga.gaUploadCustomEvent('客户-seed公客池-筛选日期');
    this.filterInfo['startTime'] = dateString[0];
    this.filterInfo['endTime'] = dateString[1];
    this.getList();
  }

  dropdownVisibleChange(open) {
    open && this.fetchUser('');
  }

  userChange(obj) {
    //@ts-ignore
    this.$ga.gaUploadCustomEvent('客户-seed公客池-筛选负责人');
    this.filterInfo['maintainer'] = obj;
    this.getList();
  }

  handleFilterChange(id, value = {}) {
    //@ts-ignore
    this.$ga.gaUploadCustomEvent(id, value);
    this.getList();
  }

  popupScroll(e) {
    // 用户列表的滚动下拉加载
    const { scrollHeight, scrollTop, clientHeight } = e.target;
    const END = scrollHeight - scrollTop <= clientHeight;
    const GETALL = this.userList.length - 1 >= this.userPagination['total'];
    if (END && !GETALL) {
      this.userPagination['page']++;
      this.fetching = true;
      searchNickNamePage(this.userKeyWord, this.userPagination['page']).then(res => {
        this.fetching = false;
        let list = res.data.list;
        this.userPagination['total'] = res.data.total;
        this.userList = this.userList.concat(list);
      });
    }
  }

  fetchUser(value) {
    this.fetching = true;
    this.userPagination['page'] = 1;
    searchNickName(value).then(res => {
      this.fetching = false;
      let list = res.data.list;
      this.userPagination['total'] = res.data.total;
      this.userPagination['page'] = res.data.page;
      list.unshift({ id: '', nickname: '全部' });
      this.userList = list;
      this.userKeyWord = value;
    });
  }

  toDetail(id) {
    window.open(window.location.origin + `/kp/seed/detail?id=${id}`);
  }

  async submitDevelopment(row) {
    this.confirmLoading = true;

    let res = await setKpField({
      kpId: this.developmentId,
      source: 1,
      latestDevelopment: this.developmentNow
    });

    if (res.code === 200) {
      this.$message.success('提交成功!');
      this.developmentNow = '';
      this.pageInfo['needPageInfo'] = true;
      this.getList();
      this.showDevelopment = false;
    }
    this.confirmLoading = false;
  }

  openDevelopment(row) {
    this.developmentId = row.baseInfo.id;
    this.developmentUser = row.baseInfo.name;
    this.showDevelopment = true;
  }

  openKpEdit(row, type) {
    this.kpEditInfo = row;
    this.kpEditType = type;
    this.showKpEdit = true;
  }

  hideKpEdit(type) {
    this.showKpEdit = false;
    this.kpEditInfo = {};
    if (type !== 'cancel') {
      this.pageInfo['needPageInfo'] = type === 'edit' ? true : false;
      this.getList();
    }
  }
}

export default KPList;
